export default __webpack_public_path__ + "static/media/Custom.0bb5f436.svg";